import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

import api from 'src/api'
import { BestMileStops } from 'src/api/gen/api'
import { userHasPermission } from 'src/commons/permissions'

import StopsTable from './StopsTable'

interface IProps {
  stops: BestMileStops[]
  stopsCount: number
}

function StopsList(props: IProps) {
  const classes = useStyles()

  let onClickExport
  if (userHasPermission(['analyze', 'gbfs'])) {
    onClickExport = async function () {
      return await api.bestmile.bestmileStopsExport()
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <StopsTable data={props.stops} totalCount={props.stopsCount} onClickExport={onClickExport} />
      </div>
    </div>
  )
}

const useStyles = makeStyles({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 'inherit',
  },
  content: {
    width: '100%',
    height: '100%',
    display: 'flex',
    borderRadius: 'inherit',
    maxHeight: 'inherit',
  },
})

export default StopsList
